import React from 'react'
import MyClassOld from '../../../modules/MyClass/index-old'

const MyClassPage = () => {
  return <MyClassOld />
}

export default MyClassPage
